"use client";

import { DemoMaskedText } from "@/components/demo/DemoMaskedText";
import { cn } from "@/lib/utils";
import Image from "next/image";
import { publicAsset } from "@/lib/public-assets";

export const PapersFeatures = ({
  className = '',
}: {
  className?: string;
}) => {
  const features = [{
    url: publicAsset('/images/icons/feature-ai-literature-review.svg'),
    caption: 'AI 文献综述',
    description: '仅需 3 步轻松整理文献综述初稿，大幅提升综述写作效率',
  }, {
    url: publicAsset('/images/icons/feature-ai-table-icon.svg'),
    caption: 'AI 表格列',
    description: 'Findin AI 快速从论文中提取关键信息，并以表格形式呈现，方便多篇文献查阅',
  }, {
    url: publicAsset('/images/icons/feature-literature-qa-icon.svg'),
    caption: 'AI 文献问答',
    description: '根据文献内容回答问题，助你深入理解原文，还可轻松跳至原文对照',
  }, {
    url: publicAsset('/images/icons/feature-read-notes-icon.svg'),
    caption: '笔记摘录',
    description: '支持大纲和思维导图笔记形式，还可随时划线摘录及截图，帮助快速梳理文献思路',
  }, {
    url: publicAsset('/images/icons/feature-compare-translation-icon.svg'),
    caption: 'AI 文献对照翻译',
    description: '支持大模型对 PDF 文献进行双语翻译，沉浸式对照阅读，提高阅读效率',
    comingsoon: false,
  }]
  return (
    <div className={cn(
      "flex flex-col justify-center items-center w-3/5",
      className,
    )}>
      <div>
        <h2 className="font-semibold text-2xl">
          <DemoMaskedText>10 倍速你的论文读写</DemoMaskedText>
        </h2>
        {/* <p className="text-sm text-muted-foreground mt-2">与Findin AI 协作，加速课题研究，迅速产出成果</p> */}
      </div>
      <div className="flex space-x-10 mt-5">
        {
          features.map(({ url, caption, description, comingsoon = false }) => {
            return (
              <div
                key={caption}
                className="relative pt-7"
              >
                <Image
                  priority
                  className="absolute top-0 left-3 pointer-events-none"
                  src={url}
                  width={84}
                  height={84}
                  alt={caption}
                />
                <div className="border border-border bg-[#FBFDFF] rounded-xl min-w-[180px] max-w-[240px] min-h-[190px] p-[19px] pb-0">
                  <h3 className="font-medium text-lg mt-7 flex items-center">
                    <DemoMaskedText as="span">{caption}</DemoMaskedText>
                    {
                      comingsoon ? (
                        <div className="relative flex-1 ml-1">
                          <span
                            className="bg-annotation-foreground/50 text-annotation text-xs px-2 py-1 rounded-md  block w-fit"
                          >
                            即将推出
                          </span>
                        </div>
                      ) : null
                    }
                  </h3>
                  <p className="font-normal text-sm text-muted-foreground mt-2.5 text-wrap text-justify">
                    <DemoMaskedText as="span">{description}</DemoMaskedText>
                  </p>
                </div>
              </div>
            )
          })
        }

      </div>
    </div>
  );
}
